import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/about/Hero';
import Mission from '../components/about/Mission';
import WhoWeAre from '../components/about/WhoWeAre';
import Approach from '../components/about/OurApproach';
import Values from '../components/about/Values';
import Vision from '../components/about/Vision';
import Cta from '../components/about/Cta';

const AboutPage = () => {
    return (
        <div className="min-h-screen bg-black text-white font-light">
            <Helmet>
                <title>About Frost & Grey | AI Training & Transformation Company</title>

                <meta
                    name="description"
                    content="Frost & Grey is an AI education and consulting company helping professionals and organizations leverage AI responsibly. Learn about our mission, leadership, and commitment to empowering Africa’s AI workforce."
                />

                <link rel="canonical" href="https://frostandgrey.com/about" />

                <meta property="og:title" content="About Frost & Grey" />
                <meta property="og:description" content="Discover the mission, values, and leadership behind Frost & Grey’s AI transformation work across Africa." />
                <meta property="og:url" content="https://frostandgrey.com/about" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Hero />
            <Mission />
            <WhoWeAre />
            <Approach />
            <Values />
            <Vision />
            <Cta />
        </div>
    );
};

export default AboutPage;